import useSWR from "swr";
import { Section } from "@/components/section";
import { RowCard } from "@/components/list/row-card";
import { RowIndex } from "@/components/list/row-index";
import { ListEmpty, ListLoading } from "@/components/list/status-text";
import { RefreshButton } from "@/components/list/refresh-button";
import { useAuthStore } from "@/lib/swr";
import type { App } from "@/types/domain";
import { ArchiveAppDialog } from "./archive-app-dialog";

// Owner recovery is available outside the admin-only route tree.
const ArchivedApps = () => {
  const me = useAuthStore((store) => store.auth?.user);
  const { data, error, isLoading, isValidating, mutate } = useSWR<App[]>(
    me?.kind !== "bot" ? ["/apps/archived"] : null,
  );
  return (
    <Section title="Archived apps" action={<RefreshButton spinning={isValidating} onClick={() => mutate()} />}>
      {isLoading && <ListLoading />}
      {error && <p role="alert" className="text-sm text-destructive">Could not load archived apps.</p>}
      {!isLoading && !error && !data?.length && <ListEmpty>No archived apps.</ListEmpty>}
      <div className="flex flex-col gap-1">
        {data?.map((app, index) => (
          <RowCard key={app.id}>
            <RowIndex n={index + 1} />
            <span className="min-w-0 flex-1 truncate">{app.name}</span>
            <ArchiveAppDialog app={app} />
          </RowCard>
        ))}
      </div>
    </Section>
  );
};

export default ArchivedApps;
